module.exports = __webpack_public_path__ + "static/media/avatar_1.35514f46.svg";